<template>
  <div class="X5Detail_container" style="height:100%">
    <div
      @wheel.prevent="handleScroll"
      v-if="!isMobile"
      class="X5Details scroll"
    >
      <div class="X5_img" :style="'height:' + screenHeight + 'px'">
        <img :src="require('../../images/X5/X5_1.png')" alt="" />
        <transition name="fade_yidong">
          <div v-show="scrollY < 0.5 * screenHeight" class="info">
            <div
              :style="index === X5_data.length - 1 ? 'border-right:none' : ''"
              v-for="(item, index) in X5_data"
              :key="item.property"
              class="item"
            >
              <div class="value">{{ item.value }}</div>
              <div class="label">{{ item.label }}</div>
            </div>
            <div class="buy_father">
              <button class="buy" @click="goBuy">订购我的X5</button>
            </div>
          </div>
        </transition>
      </div>
      <div class="X5_introduce" :style="'height:' + screenHeight + 'px'">
        <div style="flex:1">
          <video
            id="video0"
            :muted="true"
            style="width:100%;height:100%;object-fit:cover"
            loop
            :src="videoList[0]"
          ></video>
        </div>
        <div class="introduction pr">
          <transition name="fade_yidong">
            <div
              v-show="
                scrollY >= 0.5 * screenHeight && scrollY < 1.5 * screenHeight
              "
            >
              <div class="title">设计结构篇</div>
              <div class="content">
                990个SKU高容量单元柔性旋转系统
              </div>
              <div class="params">
                <img :src="require('../../images/X5/X5_2_A.png')" alt="" />
                <div style="margin-bottom:32px" class="word">
                  设备外占地仅1.5㎡大小
                </div>
                <img :src="require('../../images/X5/X5_2_B.png')" alt="" />
                <div style="margin-bottom:32px" class="word">
                  内部可放置990个完全不同的商品
                </div>
                <img :src="require('../../images/X5/X5_2_C.png')" alt="" />
                <div class="word">
                  并且以25mm为单位，在50~1500 (mm)高度内任意调节
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div class="X5_introduce" :style="'height:' + screenHeight + 'px'">
        <div class="introduction pl">
          <transition name="fade_yidong">
            <div
              v-show="
                scrollY >= 1.5 * screenHeight && scrollY < 2.5 * screenHeight
              "
            >
              <div class="title">自动调节双安全门系统</div>
              <div class="content">
                双门设计加倍防护
              </div>
              <div class="params">
                <img :src="require('../../images/X5/X5_3_A.png')" alt="" />
                <div style="margin-bottom:32px" class="word">
                  货格窗口自动校准防止货物受损
                </div>
                <img :src="require('../../images/X5/X5_3_B.png')" alt="" />
                <div class="word">
                  人性化智能感应原理，避免使用过程中意外受伤
                </div>
              </div>
              <video
                :muted="true"
                id="videoSide"
                style="width:100%;object-fit:cover;height:100%;margin-top:48px"
                loop
                :src="require('../../images/shipinside.mp4')"
              ></video>
            </div>
          </transition>
        </div>
        <div style="flex:1">
          <img :src="require('../../images/X5/X5_2.jpg')" alt="" />
        </div>
      </div>
      <div class="X5_img" :style="'height:' + screenHeight + 'px'">
        <!-- <img :src="require('../../images/X5/X5_4.png')" alt="" /> -->
        <video
          :muted="true"
          id="video1"
          style="width:100%;object-fit:cover;height:100%;padding-top: 53px;"
          loop
          :src="videoList[1]"
        ></video>
        <el-collapse-transition>
          <div
            v-show="
              scrollY >= 2.5 * screenHeight && scrollY < 3.5 * screenHeight
            "
            class="fiexedBottom"
          >
            <div class="title">货格智能扫描识别系统</div>
            <div class="word">精准定位无需烦忧</div>
            <!-- <div class="item">
              <img
                class="point"
                :src="require('../../images/home/point.png')"
                alt=""
              />精准定位，智能扫描获取数据信息，快速高效完成作业流程
            </div> -->
            <div class="item">
              <img
                class="point"
                :src="require('../../images/home/point.png')"
                alt=""
              />一键开启智能扫描系统
            </div>
            <div class="item">
              <img
                class="point"
                :src="require('../../images/home/point.png')"
                alt=""
              />精准定位货格信息
            </div>
            <div class="item">
              <img
                class="point"
                :src="require('../../images/home/point.png')"
                alt=""
              />精准计算货道数量
            </div>
          </div>
        </el-collapse-transition>
      </div>
      <div class="X5_introduce" :style="'height:' + screenHeight + 'px'">
        <div style="flex:1">
          <video
            :muted="true"
            id="video2"
            style="width:100%;object-fit:cover;height:100%"
            loop
            :src="videoList[2]"
          ></video>
        </div>
        <div class="introduction pr">
          <transition name="fade_yidong">
            <div
              v-show="
                scrollY >= 3.5 * screenHeight && scrollY < 4.5 * screenHeight
              "
            >
              <div class="title">多媒体组合品牌展示</div>
              <div class="content">
                多种展示方式全方位营销
              </div>
              <div class="params">
                <img :src="require('../../images/X5/X5_5_A.png')" alt="" />
                <div style="margin-bottom:32px" class="word">
                  侧面整块LCD屏幕设计<br />支持视频的动态展示
                </div>
                <img :src="require('../../images/X5/X5_5_B.png')" alt="" />
                <div style="margin-bottom:32px" class="word">
                  侧面整体橱窗设计<br />支持商品直观展示
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div class="X5_introduce" :style="'height:' + screenHeight + 'px'">
        <div class="introduction pl">
          <transition name="fade_yidong">
            <div
              v-show="
                scrollY >= 4.5 * screenHeight && scrollY < 5.5 * screenHeight
              "
            >
              <div class="title">多种身份识别系统</div>
              <div class="content">
                快速便捷不止一种方式
              </div>
              <div class="params">
                <img :src="require('../../images/X5/X5_6_A.png')" alt="" />
                <div style="margin-bottom:32px" class="word">
                  精准人脸识别
                </div>
                <img :src="require('../../images/X5/X5_6_B.png')" alt="" />
                <div style="margin-bottom:32px" class="word">
                  精密指纹识别
                </div>
                <img :src="require('../../images/X5/X5_6_C.png')" alt="" />
                <div style="margin-bottom:32px" class="word">
                  二代身份证识别
                </div>
                <img :src="require('../../images/X5/X5_6_D.png')" alt="" />
                <div class="word">
                  NFC卡传感等多种方式
                </div>
              </div>
            </div>
          </transition>
        </div>
        <div style="flex:1">
          <video
            :muted="true"
            id="video3"
            style="width:100%;object-fit:cover;height:100%"
            loop
            :src="videoList[3]"
          ></video>
        </div>
      </div>
      <div class="X5_introduce" :style="'height:' + screenHeight + 'px'">
        <div style="flex:1">
          <video
            :muted="true"
            id="video4"
            style="width:100%;object-fit:cover;height:100%"
            loop
            :src="videoList[4]"
          ></video>
        </div>

        <div class="introduction pl">
          <transition name="fade_yidong">
            <div
              v-show="
                scrollY >= 5.5 * screenHeight && scrollY < 6.5 * screenHeight
              "
            >
              <div class="title">电源智能化管理系统</div>
              <div class="content">
                安全用电智能保护
              </div>
              <div style="padding: 24px 48px;" class="params">
                <div style="margin-bottom:24px" class="word">
                  内置智能UPS电源模块，蓄电保护
                </div>
                <div style="margin-bottom:24px" class="word">
                  内含标配电表，即插即用
                </div>
                <div class="word">
                  支持远程抄表
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div class="X5_img" :style="'height:' + screenHeight + 'px'">
        <img :src="require('../../images/X5/X5_5.png')" alt="" />
        <transition name="fade_yidong">
          <div
            v-show="
              scrollY >= 6.5 * screenHeight && scrollY < 7.5 * screenHeight
            "
            class="last"
          >
            <div class="title">X5-工业领取新体验</div>
            <button class="buy" @click="goBuy">订购我的X5</button>
            <el-popover
              placement="bottom"
              transition="el-zoom-in-top"
              width="240"
              trigger="click"
              popper-class="qrCode_father"
            >
              <div class="q_content">
                <div class="top">微仓官方客服账号</div>
                <div class="content">
                  <img class="qrcode" src="../../images/qrcode.png" alt="" />
                  <div class="tips">微信扫码立即咨询</div>
                </div>
              </div>
              <button slot="reference" class="see">立即咨询</button>
            </el-popover>
          </div>
        </transition>
      </div>
    </div>

    <!-- 移动端界面 -->
    <div id="mobile_X5Details" v-if="isMobile" class="mobile_X5Details">
      <div class="X5_img">
        <img v-lazy="require('../../images/mobile_X5/X5_1.png')" alt="" />
        <div class="info">
          <div
            :style="index === X5_data.length - 1 ? 'border-right:none' : ''"
            v-for="(item, index) in X5_data"
            :key="item.property"
            class="item"
          >
            <div class="value">{{ item.value }}</div>
            <div class="label">{{ item.label }}</div>
          </div>
          <div class="buy_father">
            <button class="buy" @click="goBuy">订购我的X5</button>
          </div>
        </div>
      </div>
      <div class="X5_img">
        <video
          style="width:100%"
          class="video"
          :src="videoList[0]"
          :controls="false"
          x5-video-player-type="h5"
          webkit-playsinline="true"
          x-webkit-airplay="true"
          playsinline="true"
          autoplay
          x5-video-player-fullscreen="true"
          muted="true"
          loop
          :poster="posterList[0]"
        ></video>

        <div class="word">
          <div class="title">设计结构篇</div>
          <div class="smallTitle">990个SKU高容量单元柔性旋转系统</div>
          <div class="introduction">
            <img v-lazy="require('../../images/X5/X5_2_A.png')" alt="" />
            <div class="label">设备外占地仅1.5㎡大小</div>
            <img v-lazy="require('../../images/X5/X5_2_B.png')" alt="" />
            <div class="label">内部可放置990个完全不同的商品</div>
            <img v-lazy="require('../../images/X5/X5_2_C.png')" alt="" />
            <div class="label">
              以25mm为单位，在50~1500(mm)<br />高度内任意调节
            </div>
          </div>
        </div>
      </div>
      <div class="X5_img">
        <img v-lazy="require('../../images/X5/X5_2.jpg')" alt="" />
        <div class="word">
          <div class="title">自动调节双安全门系统</div>
          <div class="smallTitle">双门设计加倍防护</div>
          <div class="introduction">
            <img v-lazy="require('../../images/X5/X5_3_A.png')" alt="" />
            <div class="label">货格窗口自动校准防止货物受损</div>
            <img v-lazy="require('../../images/X5/X5_3_B.png')" alt="" />
            <div class="label">
              人性化智能感应原理，避免使用过<br />程中意外受伤
            </div>
          </div>
        </div>
      </div>
      <div class="X5_img">
        <video
          style="width:100%"
          class="video"
          :src="videoList[1]"
          :controls="false"
          x5-video-player-type="h5"
          webkit-playsinline="true"
          x-webkit-airplay="true"
          playsinline="true"
          autoplay
          x5-video-player-fullscreen="true"
          muted="true"
          loop
          :poster="posterList[1]"
        ></video>
        <div class="word">
          <div class="title">货格智能扫描识别系统</div>
          <div class="smallTitle">精准定位无需烦忧</div>
          <div class="introduction">
            <div class="label">
              <img :src="require('../../images/X5/X5_4_A.png')" alt="" />
              一键开启智能扫描系
            </div>
            <div class="label">
              <img :src="require('../../images/X5/X5_4_B.png')" alt="" />

              精准定位货格信息
            </div>
            <div class="label">
              <img :src="require('../../images/X5/X5_4_C.png')" alt="" />

              精准计算货道数量
            </div>
          </div>
        </div>
      </div>
      <div class="X5_img">
        <video
          style="width:100%"
          class="video"
          :src="videoList[2]"
          :controls="false"
          x5-video-player-type="h5"
          webkit-playsinline="true"
          x-webkit-airplay="true"
          playsinline="true"
          autoplay
          x5-video-player-fullscreen="true"
          muted="true"
          loop
          :poster="posterList[2]"
        ></video>
        <div class="word">
          <div class="title">多媒体组合品牌展示</div>
          <div class="smallTitle">多种展示方式全方位营销</div>
          <div class="introduction">
            <img v-lazy="require('../../images/X5/X5_5_A.png')" alt="" />
            <div class="label">
              侧面整块LCD屏幕设计，支持视频<br />的动态展示
            </div>
            <img v-lazy="require('../../images/X5/X5_5_B.png')" alt="" />
            <div class="label">侧面整体橱窗设计，支持商品直观<br />展示</div>
          </div>
        </div>
      </div>
      <div class="X5_img">
        <video
          style="width:100%"
          class="video"
          :src="videoList[3]"
          :controls="false"
          x5-video-player-type="h5"
          webkit-playsinline="true"
          x-webkit-airplay="true"
          playsinline="true"
          autoplay
          x5-video-player-fullscreen="true"
          muted="true"
          loop
          :poster="posterList[3]"
        ></video>
        <div class="word">
          <div class="title">多种身份识别系统</div>
          <div class="smallTitle">快速便捷不止一种方式</div>
          <div class="introduction clearfix">
            <div class="item">
              <img v-lazy="require('../../images/X5/X5_6_A.png')" alt="" />
              <div class="label">人脸识别</div>
            </div>
            <div class="item">
              <img v-lazy="require('../../images/X5/X5_6_B.png')" alt="" />
              <div class="label">指纹识别</div>
            </div>
            <div class="item">
              <img v-lazy="require('../../images/X5/X5_6_C.png')" alt="" />
              <div class="label">二代身份证<br />识别</div>
            </div>
            <div class="item">
              <img v-lazy="require('../../images/X5/X5_6_D.png')" alt="" />
              <div class="label">NFC卡传感 <br />等多种方式</div>
            </div>
          </div>
        </div>
      </div>
      <div class="X5_img">
        <video
          style="width:100%"
          class="video"
          :src="videoList[4]"
          :controls="false"
          x5-video-player-type="h5"
          webkit-playsinline="true"
          x-webkit-airplay="true"
          playsinline="true"
          autoplay
          x5-video-player-fullscreen="true"
          muted="true"
          loop
          :poster="posterList[4]"
        ></video>
        <div class="word">
          <div class="title">电源智能化管理系统</div>
          <div class="smallTitle">精准定位无需烦忧</div>
          <div class="introduction">
            <div class="label">
              <img :src="require('../../images/X5/X5_7_A.png')" alt="" />
              内置智能UPS电源模块，蓄电保护
            </div>
            <div class="label">
              <img :src="require('../../images/X5/X5_7_B.png')" alt="" />
              内含标配电表，即插即用
            </div>
            <div class="label">
              <img :src="require('../../images/X5/X5_7_C.png')" alt="" />
              支持远程抄表
            </div>
          </div>
        </div>
      </div>
      <div class="X5_img">
        <img v-lazy="require('../../images/mobile_X5/X5_5.png')" alt="" />
        <div class="lastLabel">X5-工业领取新体验</div>
        <div class="last">
          <button class="buy" @click="goBuy">订购我的X5</button>
          <!-- <el-tooltip
            class="item"
            effect="dark"
            content="敬请期待"
            placement="bottom"
          > -->
          <button @click="handleConsult" class="see">立即咨询</button>

          <!-- </el-tooltip> -->
        </div>
      </div>
      <PageBottom v-if="isMobile"></PageBottom>
    </div>
    <img
      @click="ScrollToTop"
      class="up_top"
      v-show="scrollY > 400"
      :src="require('../../images/up.png')"
      alt=""
    />
  </div>
</template>

<script>
import store from "../../store";
import PageBottom from "../../components/pageBottom";
import "video.js/dist/video-js.css";
var throttle = true;
var timer;
var throttle1 = true;
var timer1;

export default {
  data() {
    return {
      X5_data: [
        { property: "length", label: "高mm", value: "2300" },
        { property: "width", label: "宽mm", value: "1280" },
        { property: "voltage", label: "深mm", value: "1250" },
        { property: "height", label: "电压v", value: "220" },
        { property: "storage", label: "容量SKU", value: "990" }
      ],
      scrollY: 0,
      currentImg: 0,
      allPage: 7,
      videoList: [
        require("../../images/shipin.mp4"),
        require("../../images/shipin1.mp4"),
        require("../../images/shipin2.mp4"),
        require("../../images/shipin3.mp4"),
        require("../../images/shipin4.mp4")
      ],
      posterList: [
        require("../../images/poster/poster.png"),
        require("../../images/poster/poster1.png"),
        require("../../images/poster/poster2.png"),
        require("../../images/poster/poster3.png"),
        require("../../images/poster/poster4.png")
      ]
    };
  },
  computed: {
    isMobile() {
      return store.state.isMobile;
    },
    screenHeight() {
      return store.state.screenHeight;
    }
  },
  methods: {
    handleConsult() {
      if (/MicroMessenger/i.test(window.navigator.userAgent)) {
        window.open("https://work.weixin.qq.com/kfid/kfccaf9816b18773798");
      } else {
        this.$router.push("/qrCode");
      }
    },
    ScrollToTop() {
      // console.log(window);
      // window.scrollTo({
      //   top: 0,
      //   behavior: "smooth",
      // });
      this.scrollSmoothTo(0);
      this.currentImg = 0;
      this.scrollY = 0;
    },
    goBuy() {
      this.$router.push("/buy");
    },
    scrollSmoothTo(position) {
      if (!window.requestAnimationFrame) {
        window.requestAnimationFrame = function(callback, element) {
          return setTimeout(callback, 18);
        };
      }
      // 当前滚动高度
      var scrollTop = this.scrollY;
      // 滚动step方法
      var step = function() {
        // 距离目标滚动距离
        var distance = position - scrollTop;
        // 目标滚动位置
        scrollTop = scrollTop + distance / 18;
        let e = document.getElementsByClassName("X5Details")[0];
        if (Math.abs(distance) < 1) {
          if (e.scrollTo) {
            e.scrollTo(0, position);
          } else {
            e.scrollTop = position;
          }
        } else {
          if (e.scrollTo) {
            e.scrollTo(0, scrollTop);
          } else {
            e.scrollTop = scrollTop;
          }
          requestAnimationFrame(step);
        }
      };
      step();
    },
    handleScroll(e) {
      var that = this;
      if (throttle) {
        clearTimeout(timer);
        throttle = false;

        let direction = e.deltaY > 0 ? "down" : "up";
        if (direction === "down") {
          if (that.currentImg < this.allPage) {
            this.scrollSmoothTo(that.screenHeight * (that.currentImg + 1));
            that.scrollY = that.screenHeight * (that.currentImg + 1);
            that.currentImg = that.currentImg + 1;
          }
        } else {
          if (that.currentImg > 0) {
            this.scrollSmoothTo(that.screenHeight * (that.currentImg - 1));

            that.scrollY = that.screenHeight * (that.currentImg - 1);
            that.currentImg = that.currentImg - 1;
          }
        }

        timer = setTimeout(() => {
          throttle = true;
        }, 2300);
      }
    }
  },
  watch: {
    isMobile: function(value) {
      setTimeout(() => {
        if (!value) {
          document.getElementsByClassName("topNav")[0].style.right =
            document.getElementsByClassName("topNav")[0].offsetWidth -
            document.getElementsByClassName("X5_img")[0].offsetWidth +
            "px";
        } else {
          document.getElementsByClassName("topNav")[0].style.right = 0;
        }
      }, 0);
    }
  },
  mounted() {
    if (!this.isMobile) {
      document.getElementsByClassName("topNav")[0].style.right =
        document.getElementsByClassName("topNav")[0].offsetWidth -
        document.getElementsByClassName("X5_img")[0].offsetWidth +
        "px";
      this.currentImg = document.getElementsByClassName("X5Details")[0]
        .scrollTop
        ? Math.ceil(
            document.getElementsByClassName("X5Details")[0].scrollTop /
              this.screenHeight
          )
        : 0;

      document.getElementsByClassName("X5Details")[0].onscroll = e => {
        throttle1 = false;
        clearTimeout(timer1);
        timer1 = setTimeout(() => {
          throttle1 = true;
          if (throttle1) {
            this.scrollY = e.target.scrollTop;
            this.currentImg = e.target.scrollTop
              ? Math.ceil(e.target.scrollTop / this.screenHeight)
              : 0;

            switch (this.currentImg) {
              case 1:
                this.videoList.forEach((item, index) => {
                  if (index === 0) {
                    document.getElementById("video" + index).play();
                  } else {
                    document.getElementById("video" + index).pause();
                  }
                });
                break;
              case 2:
                document.getElementById("videoSide").play();
                this.videoList.forEach((item, index) => {
                  document.getElementById("video" + index).pause();
                });
                break;
              case 3:
                this.videoList.forEach((item, index) => {
                  if (index === 1) {
                    document.getElementById("video" + index).play();
                  } else {
                    document.getElementById("video" + index).pause();
                  }
                });
                break;
              case 4:
                this.videoList.forEach((item, index) => {
                  if (index === 2) {
                    document.getElementById("video" + index).play();
                  } else {
                    document.getElementById("video" + index).pause();
                  }
                });
                break;
              case 5:
                this.videoList.forEach((item, index) => {
                  if (index === 3) {
                    document.getElementById("video" + index).play();
                  } else {
                    document.getElementById("video" + index).pause();
                  }
                });
                break;
              case 6:
                this.videoList.forEach((item, index) => {
                  if (index === 4) {
                    document.getElementById("video" + index).play();
                  } else {
                    document.getElementById("video" + index).pause();
                  }
                });
                break;
            }
          }
        }, 200);
      };
    } else {
      this.$store.commit("edit_backgroundColor", "rgba(0, 0, 0, .3)");
      document.addEventListener("touchstart", function(e) {
        for (
          let i = document.getElementsByClassName("video").length - 1;
          i >= 0;
          i--
        ) {
          document.getElementsByClassName("video")[i].play();
        }
      });
    }
  },
  destroyed() {
    document.getElementsByClassName("topNav")[0].style.right = 0;
  },
  components: {
    PageBottom
  }
};
</script>
<style lang="less">
@import url("../../less/X5Details.less");
.X5Detail_container {
  .up_top {
    position: fixed;
    right: 40px;
    bottom: 150px;
    width: 60px;
    height: 60px;
  }
}
.X5Details {
  width: 100%;
  overflow-x: hidden;
  height: 100%;

  .pl {
    left: 0;
  }
  .pr {
    right: 0;
  }
  .X5_introduce {
    display: flex;
    padding-top: 53px;
    img {
      min-height: 100%;
      object-fit: cover;
    }
    .introduction {
      width: 415px;
      padding: 3.703704rem /* 100/27 */ 50px 0;
      background-color: #fff;
      height: 100%;
      /*实现垂直居中*/
      // display: flex;
      // align-items: center;

      .title {
        font-size: 28px;
        line-height: 40px;
        margin-bottom: 16px;
        text-align: center;
      }
      .content {
        text-align: center;
        font-weight: 700;
      }
      .params {
        width: 315px;
        background: #f0f0f0;
        border-radius: 10px;
        margin-top: 24px;
        padding: 24px 54px;
        text-align: center;
        .paramsTitle {
          font-size: 20px;
          text-align: center;
        }
        .word {
        }
        img {
          width: auto;
          margin: 0 auto 8px;
        }
        .item {
          display: flex;
          margin-bottom: 8px;
          .left {
            flex: 1;
            .left1 {
              font-weight: 700;
            }
            .left2 {
              font-size: 12px;
            }
          }
          .right {
            flex: 1;
            text-align: right;
            line-height: 39px;
          }
        }
      }
    }
  }
  .X5_img {
    position: relative;
    overflow: hidden;
    // display: flex;
    // flex-direction: column;
    img {
      height: 100%;
      object-fit: cover;
    }
    video {
      // flex: 1;
    }
    .fiexedBottom {
      position: absolute;
      top: 40%;
      left: 75%;
      color: rgba(255, 255, 255, 0.85);
      .title {
        font-size: 28px;
        margin-bottom: 10px;
      }
      .word {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 0.48rem;
      }
      .item {
        font-size: 14px;
        margin-bottom: 8px;
        .point {
          width: 4px;
          height: 4px;
          display: inline-block;
          vertical-align: middle;
          margin-right: 8px;
        }
      }
    }
    .specification {
      height: 21.2vh /* 230/27 */;
      padding-top: 1.777778rem /* 48/27 */;
      display: flex;
      .left {
        .title {
          font-size: 28px;
          margin-bottom: 10px;
        }
        .word {
          font-size: 16px;
          font-weight: 700;
        }
      }
      .right {
        padding-left: 48px;
        .item {
          font-size: 14px;
          margin-bottom: 8px;
        }
      }
      // .title {
      //   font-size: 28px;
      //   margin-bottom: 21px;
      // }
      // .item {
      //   width: 50%;
      //   float: left;
      //   margin-bottom: 50px;
      //   .line {
      //     width: 28px;
      //     height: 1px;
      //     background: rgba(0, 0, 0, 0.65);
      //     margin-bottom: 14px;
      //   }
      // }
    }
    .info {
      position: absolute;
      bottom: 55px;
      text-align: center;
      left: 0;
      right: 0;
      .buy_father {
        position: relative;
        display: inline-block;
        width: 200px;
        height: 40px;
      }
      .buy {
        width: 200px;
        height: 40px;
        background: rgba(255, 255, 255, 0);
        opacity: 0.75;
        border: 1px solid #ffffff;
        color: #ffffff;
        cursor: pointer;
        position: absolute;
        top: 0;
        left: 0;
      }
      .item {
        display: inline-block;
        border-right: 1px solid white;
        width: 140px;
        text-align: center;
        margin-bottom: 10px;
        .value {
          font-size: 28px;
          color: #ffffff;
          line-height: 40px;
        }
        .label {
          font-size: 14px;
          color: #ffffff;
          line-height: 20px;
        }
      }
    }
    .last {
      position: absolute;
      left: 21%;
      top: 40%;
      .title {
        font-size: 34px;
        color: #000000;
        margin-bottom: 32px;
      }
      .buy {
        width: 200px;
        height: 40px;
        background: #000000;
        border-radius: 2px;
        opacity: 0.86;
        text-align: center;
        line-height: 40px;
        color: #ffffff;
        margin-bottom: 16px;
        cursor: pointer;
        display: block;
      }
      .see {
        width: 200px;
        height: 40px;
        background: #ffffff;
        border-radius: 2px;
        opacity: 0.86;
        text-align: center;
        line-height: 40px;
        color: #000000;
        margin-bottom: 16px;
        cursor: pointer;
        border: 1px solid #000000;
      }
    }
  }
}
</style>
